import { useEffect, useRef, useState } from "react";

export const DEFAULT_LAUNCHER_BOTTOM = 20;
const FOOTER_GAP = 20;
const FOOTER_ID = "footer";

export function calcLauncherBottom(
  footerTop: number,
  viewportHeight: number = window.innerHeight
): number {
  if (footerTop >= viewportHeight) {
    return DEFAULT_LAUNCHER_BOTTOM;
  }
  return viewportHeight - footerTop + FOOTER_GAP;
}

function getLauncherBottomFromDom(): number {
  const footer = document.getElementById(FOOTER_ID);
  if (!footer) {
    return DEFAULT_LAUNCHER_BOTTOM;
  }

  const footerTop = footer.getBoundingClientRect().top;
  const viewportHeight = window.innerHeight;

  // Position purely on footer visibility. The footerTop >= viewportHeight check above already
  // covers "footer not yet visible"; a scrollY === 0 short-circuit would wrongly keep the launcher
  // at the default bottom on short pages where the footer is visible without any scrolling.
  return calcLauncherBottom(footerTop, viewportHeight);
}

export { openChannelMessenger, useChannelTalkMessengerOpen } from "contexts/ChannelTalkContext";

export function useChannelTalkLauncherPosition(): number {
  const [bottom, setBottom] = useState(DEFAULT_LAUNCHER_BOTTOM);
  const rafIdRef = useRef(0);

  useEffect(() => {
    const sync = () => {
      setBottom(getLauncherBottomFromDom());
    };

    const scheduleSync = () => {
      cancelAnimationFrame(rafIdRef.current);
      rafIdRef.current = requestAnimationFrame(sync);
    };

    window.addEventListener("scroll", scheduleSync, { passive: true });
    window.addEventListener("resize", scheduleSync);
    scheduleSync();

    return () => {
      cancelAnimationFrame(rafIdRef.current);
      window.removeEventListener("scroll", scheduleSync);
      window.removeEventListener("resize", scheduleSync);
    };
  }, []);

  return bottom;
}
